import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { GoogleTagService } from 'src/services/services/google-tag.service';
import { NgxSpinnerService } from 'ngx-spinner';


interface Cep {
  
    "cep": string,
    "logradouro": string,
    "complemento": string,
    "unidade": string,
    "bairro": string,
    "localidade": string,
    "uf": string,
    "estado": string,
    "regiao":string,
    "ibge": string,
    "gia": string,
    "ddd": string,
    "siafi": string
  
}

interface Alert {
  type: string;
  message: string;
}

const ALERTS: Alert[] = [
  {
    type: 'success',
    message: '56% das pessoas levam um frasco extra de FIRE BIG...',
  }
];




@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent {


  valor = 59
  alerts;
  alertCards;
  mainAlert = true;

  formCliente!: FormGroup;
  
  controllerOrder: boolean = false
  cep: Cep;
  cepUser: string = ""
  controllerCep: boolean = false

  quantidade: number = 1

  freteTela: string = "R$ 10,00"

  
  cepControl = new FormControl('');

  minutos: number = 10; // 10 minutos iniciais
  segundos: number = 0;
  intervalId: any;
  valorPedido = 49
  
  sss = false

  constructor(
    private http: HttpClient,
   private modalService: NgbModal,
  private toastr: ToastrService,
  private form: FormBuilder,
  private googleTagService: GoogleTagService,
  private spinner: NgxSpinnerService,
){}

ngOnInit() {
  this.formCliente = this.form.group({
    nome: ['', Validators.required],
    cpf: ['', Validators.required],
    phone: ['', Validators.required],
    data_criacao: [`${moment().locale('pt-br').format('DD [de] MMMM [de] YYYY, HH:mm:ss')}`],
    produto: ['FIRE BIG GEL'],
    quantidade: [this.quantidade],
    valor_total: [this.valor],
    valor_frete: [10],
    status_pedido: ['Aberto'],
    status_pagamento: [''],
    status_envio: [''],
    observacao: [''],
    data_entrega: [''],
    endereco: this.form.group({
      cep: ['', Validators.required],
      logradouro: ['', Validators.required],
      complemento: [''],
      numero: ['', Validators.required],
      bairro: ['', Validators.required],
      localidade: ['', Validators.required],
      estado: ['', Validators.required],
      obs: ['']
    })
  });

  this.alerts = [...ALERTS];
  this.alertCards = [...ALERTS];
  this.iniciarCronometro()
  
}

  orderBum(){
    this.controllerOrder = true
  }

  
  registrarCompra() {

  // Envia conversão para Google Ads
  this.googleTagService.sendEvent('conversion', {
    'send_to': 'AW-11350555780/IbSHCJmN1KoZEIT5rqQq',
    'transaction_id': '12345' // ID da transação, pode ser dinâmico
  });

  // Dispara evento de compra no Facebook Pixel
  if ((window as any).fbq) {
    (window as any).fbq('track', 'Purchase', { value: this.valor, currency: 'BRL' });
  }

  // Dispara evento de início de checkout no Facebook Pixel
  if (typeof (window as any).fbq === 'function') {
    (window as any).fbq('track', 'InitiateCheckout', {
      value: this.valor,
      currency: 'BRL'
    });
  } else {
  }
}



  iniciarCronometro(): void {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        if (this.segundos === 0) {
          if (this.minutos > 0) {
            this.minutos--;
            this.segundos = 59;
          } else {
            this.zerarCronometro();
          }
        } else {
          this.segundos--;
        }
      }, 1000);
    }
  }

  pausarCronometro(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  reiniciarCronometro(): void {
    this.pausarCronometro();
    this.minutos = 10;
    this.segundos = 0;
  }

  zerarCronometro(): void {
    this.pausarCronometro();
    this.minutos = 0;
    this.segundos = 0;
    alert('Tempo esgotado!');
  }

  ngOnDestroy(): void {
    this.pausarCronometro(); // Limpa o intervalo ao destruir o componente
  }

  

  redirectToSuccessPage() {
    window.location.href = 'https://www.redsempreedimentos.space/pedido-realizado-com-sucesso/';
  }


  openSmall(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'sm' })
    .result.then((result) => {
    }, (reason) => {
    });
  }


  eventS(qtd: number){
    this.quantidade = qtd
    this.sss = !this.sss
    if(this.quantidade == 1){
      this.valor = 59
      this.valorPedido = 49
      this.freteTela = "R$ 10,00"
      this.formCliente.patchValue({
        quantidade: 1,
        valor_total: 59
      });
    } else {
      this.valorPedido = 98
      this.freteTela = "GRÁTIS"
      this.valor = 98
      this.formCliente.patchValue({
        quantidade: 2,
        valor_total: 98
      });
    }
    
  }


  buscarCep(cep: string): void {
   if(cep.length === 8){
    this.http.get<any>(`https://viacep.com.br/ws/${cep}/json/`).subscribe(
      (dados) => {
        if(!dados.erro){
          this.controllerCep = true;

          this.formCliente.patchValue({
            endereco: {
              cep: cep,
              logradouro: dados.logradouro || '',
              bairro: dados.bairro || '',
              localidade: dados.localidade || '',
              estado: dados.uf || '' // ViaCEP retorna 'uf' em vez de 'estado'
            }
          });
        }

      },
      (error) => {
      }
    );
   }
  }

  
 
    success(message: string) {
      this.toastr.success(message, 'Pedido: #2192', { positionClass: 'toast-top-right', timeOut: 30000 });
    }
 

    submitForm(event: Event) {
      event.preventDefault();
      if (this.formCliente.valid) {
        this.spinner.show();
        const obj = this.formCliente.value
        this.http.post('https://api-checkout-0dd5c008b71c.herokuapp.com/clientes', obj).subscribe(
          () => {
            this.registrarCompra()
            this.spinner.hide();
            window.location.href = 'https://www.redsempreedimentos.space/pedido-realizado-com-sucesso/';
            
          }
        )
        setTimeout(() => {
          this.spinner.hide(); 
        }, 30000);

      } 
      else {
        this.formCliente.markAllAsTouched();
        return
      }
    }

    
  
    campoInvalido(form: FormGroup, campo: string): boolean | undefined {
      return form.get(campo)?.invalid && form.get(campo)?.touched;
    }

}
